// Top bar: day, time, cash, homes; pause and speed controls.
import type { Command, World } from '../sim';
import { countHomes } from '../sim';
import { createSkyDial } from './skydial';

export interface Hud {
  update(world: World, hourSmooth: number): void;
}

export function createHud(parent: HTMLElement, emit: (c: Command) => void): Hud {
  const el = document.createElement('div');
  el.className = 'hud';
  el.innerHTML = `
    <div class="hud-left">
      <span class="hud-day"></span>
      <span class="hud-dial"></span>
      <span class="hud-time"></span>
      <span class="hud-sep">·</span>
      <span class="hud-homes"></span>
    </div>
    <div class="hud-right">
      <span class="hud-cash"></span>
      <button class="btn btn-icon hud-pause" title="Pause / resume (Space)" aria-label="Pause"></button>
      <button class="btn btn-icon hud-speed" title="Speed (1x / 2x)" aria-label="Speed">1×</button>
    </div>`;
  parent.appendChild(el);
  const q = (s: string): HTMLElement => el.querySelector(s) as HTMLElement;
  const day = q('.hud-day');
  const time = q('.hud-time');
  const homes = q('.hud-homes');
  const cash = q('.hud-cash');
  const dial = createSkyDial(q('.hud-dial'));
  const pause = q('.hud-pause') as HTMLButtonElement;
  const speed = q('.hud-speed') as HTMLButtonElement;

  let current: World | null = null;
  pause.addEventListener('click', () => {
    if (!current) return;
    emit({ t: current.status === 'paused' ? 'Resume' : 'Pause' });
  });
  speed.addEventListener('click', () => {
    if (!current) return;
    emit({ t: 'SetSpeed', speed: current.speed === 1 ? 2 : 1 });
  });
  window.addEventListener('keydown', (e) => {
    if (e.code === 'Space' && current) {
      e.preventDefault();
      emit({ t: current.status === 'paused' ? 'Resume' : 'Pause' });
    }
  });

  let last = '';
  return {
    update(world, hourSmooth) {
      current = world;
      dial.update(hourSmooth);
      const h = Math.floor(world.time.hour);
      const m = Math.floor((world.time.hour - h) * 60);
      const c = countHomes(world);
      const key = `${world.time.day}|${h}|${m}|${c.fed}|${c.total}|${Math.floor(world.cash)}|${world.status}|${world.speed}`;
      if (key === last) return;
      last = key;
      day.textContent = `Day ${world.time.day}`;
      time.textContent = `${String(h).padStart(2, '0')}:${String(Math.floor(m / 10) * 10).padStart(2, '0')}`;
      homes.textContent =
        `${c.fed} / ${c.total - c.dark} lit` + (c.dark ? ` · ${c.dark} dark` : '');
      cash.textContent = `$${Math.floor(world.cash)}`;
      cash.classList.toggle('low', world.cash < 40);
      pause.textContent = world.status === 'paused' ? '▶' : '❚❚';
      pause.classList.toggle('active', world.status === 'paused');
      speed.textContent = `${world.speed}×`;
      speed.classList.toggle('active', world.speed === 2);
      el.classList.toggle('paused', world.status === 'paused');
    },
  };
}
